"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _Title = _interopRequireDefault(require("./Title.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Title = props => {
  const {
    level = 1,
    children
  } = props;
  if (level < 1 && level > 4) {
    throw new Error('Title level must be between 1 and 4');
  }
  const styles = (0, _Title.default)(props);
  const Htag = `h${level}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Htag, {
    className: styles['cc-Title'],
    children: children
  });
};
exports.Title = Title;